<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <router-link to="/Dashboard">
            <v-btn icon dark >
              <v-icon>keyboard_backspace</v-icon>
            </v-btn>
          </router-link>
          <v-toolbar-title>PRODUCTS</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- prepend-inner-icon="search" 
              outline
              solo
              single-line  -->
          <!-- <div class="search"> -->
            <v-text-field
              prepend-inner-icon="search"
              solo
              outlined
              clearable
              :autofocus="true"
              label="Search Product" 
              @keyup.native="keymonitor($event)" />
          <!-- </div> -->
          <v-spacer></v-spacer>
            <v-switch
              color="white"
              class="white-switch"
              v-model="showOnlyActiveProd"
              :label="showOnlyActiveProd ? 'Active Products' : 'All Products'"
              ></v-switch>    
              <v-select
                :items="productGroupListByBrand"
                label="Group"
                class="white-select"
                item-text="text"
                item-value="value"
                color="white"
                v-model="selectedGroup"
                clearable
              ></v-select> 
          <v-card-actions class="justify-center">
            <v-btn outline @click="addProduct" class="white--text" :disabled="!hasProductAddPermission">
              <v-icon left dark>add</v-icon>
                NEW PRODUCT
            </v-btn>
          </v-card-actions>
        </v-toolbar>
        <v-data-table
          :headers="productListHeader"
          :items="productListByBrand"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <!-- <td>
              <b>{{ props.item['.key']}}</b>
            </td> -->
            <td>
              <b>{{ props.item['name']}}</b>
            </td>
             <!-- <td>
              <b>{{ props.item['isActive']}}</b>
            </td> -->
            <td>
              <b class="font-weight-light">{{ props.item['description'] }}</b> 
                -
              <b class="font-weight-light">{{ props.item['HSN_code']}}</b>
                -
              <b class="font-weight-light">{{ props.item['GST_type']}}</b>
                -
              <b class="font-weight-light">{{ props.item.taxableGST_rate}}</b>
            </td>
            <!-- <td>
              <b>{{ props.item['description']}}</b>
            </td> -->
            <!-- <td>
              <b>{{ props.item['HSN_code']}}</b>
            </td>
            <td>
              <b>{{ props.item['GST_type']}}</b>
            </td>
            <td>
              <b>{{ props.item.taxableGST_rate}}</b>
            </td> -->
            <td>
              <b>{{ props.item['unit']}}</b>
            </td>
            <!-- <td>
              <b v-if="props.item['openingDate']">{{ new Date(props.item['openingDate']).toISOString().substr(0, 10)}}</b>
            </td> -->
            <!-- <td>
              <b class="info--text font-weight-bold" :title="props.item.openingQuantityTitle">{{props.item['openingQuantity']}} </b>
            </td>
            <td>
              <b class="primary--text font-weight-bold" :title="props.item.purchaseQuantityTitle">{{props.item['purchaseQuantity']}}</b>
            </td>
            <td>
              <b class="green--text font-weight-bold" :title="props.item.saleQuantityTitle">{{props.item['saleQuantity']}}</b>
            </td>   --> 
            <!-- <td>
              <b class="green--text font-weight-bold" :title="props.item.closingQuantityTitle">{{props.item['quantity']}}</b>
            </td>
            <td>
              <b class="red--text font-weight-bold" :title="props.item.closingQuantityTitle">{{ ((Number.parseFloat(props.item['openingQuantity']) + Number.parseFloat(props.item['purchaseQuantity'])) -  Number.parseFloat(props.item['saleQuantity']))}}</b>
            </td> -->
            <!-- <td>
              <b class="warning--text font-weight-light">{{ props.item['openingBalance'] || 0 | amount}}</b>
            </td>
            <td>
              <b class="primary--text font-weight-bold">{{ props.item['purchaseBalance'] || 'towork' }}</b>
            </td>
            <td>
              <b class="success--text font-weight-bold">{{ props.item['saleBalance'] || 'towork' }}</b>
            </td>
            <td>
              <b class="error--text font-weight-bold">{{ props.item['closingBalance'] || 'towork'}}</b>
            </td>
            <td>
              <b>{{ props.item['purchasingPrice'] || 0 | amount}}</b>
            </td>
            <td>
              <b>{{ props.item['sellingPrice'] || 0 | amount}}</b>
            </td>
            <td>
              <b>{{ props.item['basicPrice'] || 0 | amount}}</b>
            </td>
            <td>
              <b>{{ props.item['gstValue'] || 0 | amount}}</b>
            </td> -->
            <td>
              <v-btn :disabled="!hasProductTransferPermission" icon class="mx-0" @click="openTansferDialog(props.item)">
                <v-icon color="teal">double_arrow</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="openBranchDialog(props.item)">
                <v-icon color="teal">store</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="openBatchDialog(props.item)">
                <v-icon color="teal">add</v-icon>
              </v-btn>
              <v-btn icon class="mx-0" @click="viewProductByBatch(props.item)">
                <v-icon color="blue">remove_red_eye</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn :disabled="!hasProductEditPermission" icon class="mx-0" @click="editProduct(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn :disabled="!hasProductDeletePermission" icon class="mx-0" @click="deleteProduct(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="openDamageDialog(props.item)">
                <v-icon color="red">warning</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-dialog v-model="addProductDialog" persistent fullscreen hide-overlay>
     <add-product
     v-if="addProductDialog"
     :currentProduct="currentProduct"
     :stepperValue="stepperValue"
     @updateProduct="updateProduct()"
     @saveProduct="saveProduct"
     @close="addProductDialog = false"
     />
    </v-dialog>

    <!-- Start Product Transfer Dialog -->
    <v-dialog v-model="transferDialog" persistent max-width="1000px">
      <v-card persistent>
        <v-card-title class="primary white--text">
          <span class="headline">Shift/Transfer Items</span>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-combobox
                  v-model="productToTansfer"
                  :items="productListByBrand"
                  :return-object="true"
                  item-text="name"
                  label="Product"
                ></v-combobox>
              </v-flex>
              
              <v-flex xs6 sm6 md6>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerTransfer"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="transferDate"
                    label="Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="transferDate" @input="datepickerTransfer = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <!-- <v-flex xs12 sm12 md12 style="padding-top : 14px;"> -->
                <v-flex xs6 sm6 md6>
                  <v-combobox
                    v-model="currentGodawn"
                    :items="godawnByBrand"
                    :return-object="true"
                    item-text="godawnName"
                    label="Select Godawn"
                  ></v-combobox>
                </v-flex>
              
                <v-flex xs6 sm6 md6>
                  <v-text-field
                    v-model="transferQuantity"
                    type="number"
                    label="Quantity"
                  ></v-text-field>
                </v-flex>
              <!-- </v-flex> -->
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                @click="transferDialog = false"
                flat
              >Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                @click="transferToGodawn()"
                flat
              >Move</v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <!-- End of Product Transfer Dialog -->

      <!-- Start Product Branch Transfer Dialog -->
    <v-dialog v-model="branchDialog" persistent max-width="1000px">
      <v-card persistent>
        <v-card-title class="primary white--text">
          <span class="headline">Branch - Transfer </span>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-combobox
                  v-model="productToBranch"
                  :items="productListByBrand"
                  :return-object="true"
                  item-text="name"
                  label="Product"
                ></v-combobox>
              </v-flex>
              
              <v-flex xs6 sm6 md6>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerTransfer"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="branchDate"
                    label="Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="branchDate" @input="datepickerBranch = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <!-- <v-flex xs12 sm12 md12 style="padding-top : 14px;"> -->
                <v-flex xs6 sm6 md6>
                  <v-combobox
                    v-model="currentBranch"
                    :items="branchByBrand"
                    :return-object="true"
                    item-text="branchName"
                    label="Select Branch"
                  ></v-combobox>
                </v-flex>
              
                <v-flex xs6 sm6 md6>
                  <v-text-field
                    v-model="branchQuantity"
                    type="number"
                    label="Quantity"
                  ></v-text-field>
                </v-flex>
              <!-- </v-flex> -->
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                @click="branchDialog = false"
                flat
              >Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                @click="transferToBranch()"
                flat
              >Move</v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
      <!-- End of Product Transfer Dialog -->


      <!-- Start of Batch Dialog -->
      <v-dialog v-model="batchDialog" persistent max-width="1000px">
      <v-card persistent>
        <v-card-title class="primary white--text">
          <span class="headline">Add Batch Details</span>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs3 sm3 md3>
                <v-combobox
                  v-model="productToBatch"
                  :items="productListByBrand"
                  :return-object="true"
                  item-text="name"
                  label="Product"
                ></v-combobox>
              </v-flex>
              <v-flex xs2 sm2 md2>
                  <v-text-field
                    v-model="batchNumber"
                    type="text"
                    label="BatchNumber"
                  ></v-text-field>
                </v-flex>
              
              <v-flex xs3 sm3 md3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerBatch"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="manufacuturingDate"
                    label="ManuFacturing Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="manufacuturingDate" @input="datepickerBatch = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs3 sm3 md3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="todatepickerBatch"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="expiryDate"
                    label="Expiry Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="expiryDate" @input="todatepickerBatch = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs1 sm1 md1>
                  <v-text-field
                    v-model="batchQuantity"
                    type="number"
                    label="ProductQuantity"
                  ></v-text-field>
              </v-flex>
              <!-- <v-flex xs12 sm12 md12 style="padding-top : 14px;"> -->
                <!-- <v-flex xs6 sm6 md6>
                  <v-combobox
                    v-model="currentGodawn"
                    :items="godawnByBrand"
                    :return-object="true"
                    item-text="godawnName"
                    label="Godawn"
                  ></v-combobox>
                </v-flex> -->
              
                <!-- <v-flex xs6 sm6 md6>
                  <v-text-field
                    v-model="transferQuantity"
                    type="number"
                    label="Quantity"
                  ></v-text-field>
                </v-flex> -->
              <!-- </v-flex> -->
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            @click="batchDialog = false"
            flat
            >Cancel</v-btn>
            <v-btn
              color="blue darken-1"
              @click="addToBatch()"
              flat
            >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- End of Batch Dialog -->

      <!-- view Batch Dialog -->
      <v-dialog v-model="viewBatchDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <!-- <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">View Batch Details</v-btn>
      </template> -->
      <v-card v-if="batchSelectedProduct">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="viewBatchDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Batch Details of 
              <b>{{ batchSelectedProduct['name']}}</b>
                -
              <b class="font-weight-light">HSN: {{ batchSelectedProduct['HSN_code']}}</b>
                -
              <b class="font-weight-light">GST type: {{ batchSelectedProduct['GST_type']}}</b>
                -
              <b class="font-weight-light">GST Rate: {{ batchSelectedProduct.taxableGST_rate}}</b>
                -
              <b class="font-weight-light">UNI : {{ batchSelectedProduct.unit}}</b>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-toolbar-items>
            <v-btn dark flat @click="dialog = false">Save</v-btn>
          </v-toolbar-items> -->
        </v-toolbar>
        <v-data-table
          :headers="productListHeaderByBatch"
          :items="bachList"
          hide-actions
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <td>
              <b>{{ props.item['batchNumber']}}</b>
            </td>
            <td>
              <b v-if="props.item['manufacturingDate']">{{ new Date(props.item['manufacturingDate']).toISOString().substr(0, 10)}}</b>
            </td>
            <td>
              <b v-if="props.item['expiryDate']">{{ new Date(props.item['expiryDate']).toISOString().substr(0, 10)}}</b>
            </td>
            <td>
              <b class="info--text font-weight-bold">{{ props.item['quantity'] }}</b>
            </td>
            <!-- <td>
              <v-btn icon class="mx-0" @click="editProduct(props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deleteProduct(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="openDamageDialog(props.item)">
                <v-icon color="red">warning</v-icon>
              </v-btn>
            </td> -->
          </template>
          <template slot="no-data">No Items</template>
        </v-data-table>
      </v-card>
      <!-- <v-card>  
        <v-list three-line subheader>
          <v-subheader>User Controls</v-subheader>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Content filtering</v-list-tile-title>
              <v-list-tile-sub-title>Set the content filtering level to restrict apps that can be downloaded</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Password</v-list-tile-title>
              <v-list-tile-sub-title>Require password for purchase or use password to restrict purchase</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader>
          <v-subheader>General</v-subheader>
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-checkbox v-model="notifications"></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Notifications</v-list-tile-title>
              <v-list-tile-sub-title>Notify me about updates to apps or games that I downloaded</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-checkbox v-model="sound"></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Sound</v-list-tile-title>
              <v-list-tile-sub-title>Auto-update apps at any time. Data charges may apply</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar>
            <v-list-tile-action>
              <v-checkbox v-model="widgets"></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Auto-add widgets</v-list-tile-title>
              <v-list-tile-sub-title>Automatically add home screen widgets</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card> -->
    </v-dialog>
    <!-- view Batch Dialog -->

    <!-- Start Damage dialog -->
    <v-dialog v-model="damageDialog" persistent max-width="1000px">
      <v-card persistent>
        <v-card-title class="primary white--text">
          <span class="headline">DamageList</span>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-combobox
                  v-model="productToDamage"
                  :items="productListByBrand"
                  :return-object="true"
                  item-text="name"
                  label="Product"
                ></v-combobox>
              </v-flex>
              
              <v-flex xs6 sm6 md6>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerDamage"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="damageDate"
                    label="Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="damageDate" @input="datepickerDamage = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <!-- <v-flex xs12 sm12 md12 style="padding-top : 14px;"> -->
                <!-- <v-flex xs6 sm6 md6>
                  <v-combobox
                    v-model="currentGodawn"
                    :items="godawnByBrand"
                    :return-object="true"
                    item-text="godawnName"
                    label="Godawn"
                  ></v-combobox>
                </v-flex> -->
              
                <v-flex xs6 sm6 md6>
                  <v-text-field
                    v-model="damageQuantity"
                    type="number"
                    label="Damage Quantity"
                  ></v-text-field>
                </v-flex>
              <!-- </v-flex> -->
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                @click="damageDialog = false"
                flat
              >Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                @click="transferToDamage()"
                flat
              >Save</v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
       <v-dialog v-model="passwordDialog" width="800" persistent>
        <v-card>
          <v-card-title class="headline primary--text" primary-title>
            Enter the password
            <v-spacer></v-spacer>
            <v-btn icon dark class="primary" @click="passwordDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
             <v-text-field
              v-model="password"
              type="password"
              label="Password"
              autocomplete="false"
            ></v-text-field>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
             <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteFromDialog()">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- End of Damage Dialog -->

    <v-snackbar :timeout="timeout" top v-model="snackbar" color="primary">
      Thank You so Much 
      <!-- <h3 class="font-weight-bold"> 
        {{getSelectedbrandName}} </h3>  -->
        To make you serve Better.
    </v-snackbar>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import AddProduct from "./addProduct";
export default {
    components: {
    AddProduct
  },
  data() {
    return {
      isBuyer: true,
      search : null,
      selectedGroup : null,
      stepperValue : 1,
      compositionSuggestions : [],
      suggestionAdded : false,
      showOnlyActiveProd : true,
      transferDialog : false,
      branchDialog : false,
      viewBatchDialog: false,
      batchDialog : false,
      damageDialog : false,
      isOpeningBalance: false,
      isStanderedPrice: false,
      addProductDialog: false,
      productToTansfer : null,
      productToBranch : null,
      productToBatch : null,
      productToDamage : null,
      datepickerTransfer : false,
      datepickerBranch : false,
      datepickerBatch : false,
      todatepickerBatch : false,
      datepickerDamage : false,
      currentGodawn : null,
      currentBranch : null,
      transferQuantity :0,
      branchQuantity :0,
      batchQuantity :0,
      damageQuantity :0,
      batchNumber:"",
      brand : {},
      datepicker : false,
      duplicateError : null,
      transferDate : new Date().toISOString().substr(0, 10),
      branchDate : new Date().toISOString().substr(0, 10),
      manufacuturingDate : new Date().toISOString().substr(0, 10),
      expiryDate : new Date().toISOString().substr(0, 10),
      damageDate : new Date().toISOString().substr(0, 10),
      currentProduct: {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        unit: "",
        quantity: 0,
        brand: "",
        openingDate : new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue : 0,
        basicPrice : 0,
        barcode:"",
        productGroup:null,
        productCategory:null,
        productType:null,
        unitsDetails : [
          {
            unit:'',
            isLast: true,
            isFirst:true,
            order : 1,
            quantity : 0,
            rate: true
          }
        ],
        unitsDeatilsAdded : false,
        isActive: true,
      },
      timeout : 3000,
      snackbar : false,
      productList: [],
      productListHeader: [
        // { text: "Product- ID", value: "Product - ID" },
        { text: "Product Name" , value: "name", sortable: true },
        { text: "Description", value: "Description" },
        // { text: "HSN code", value: "HSN" },
        // { text: "GST type", value: "GST" },
        // { text: "Taxable rate", value: "Taxable" },
        { text: "Unit", value: "Unit" },
        // { text: "Opening Date", value: "quantity" },
        // { text: "Opening Quantity", value: "quantity" },
        // { text: "Purchase Quantity", value: "quantity" },
        // { text: "Sale Quantity", value: "quantity" },
        // { text: "Available Quantity", value: "quantity" },
        // { text: "Opening Balance", value: "quantity" },
        // { text: "Purchase Balance", value: "quantity" },
        // { text: "Sale Balance", value: "quantity" },
        // { text: "Closing Balance", value: "quantity" },
        // { text: "Purchasing Price", value: "quantity" },
        // { text: "Selling Price", value: "quantity" },
        // { text: "Basic Price", value: "quantity" },
        // { text: "Gst Value", value: "quantity" },
        { text: "Transfer", value: "transfer" },
        { text: "Branch", value: "branch" },
        { text: "Batch", value: "transfer", },
        { text: "Edit", value: "edit" },
        { text: "Delete", value: "delete" },
        { text: "Damage", value: "transfer" },
      ],
      productListHeaderByBatch: [
        { text: "Batch", value: "batch" },
        { text: "Manufacturing Date", value: "manuDate" },
        { text: "Expiry Date", value: "expiryDate" },
        { text: "Quantity", value: "quantity" },
        // { text: "Purchase Quantity", value: "quantity" },
        // { text: "Sale Quantity", value: "quantity" },
        // { text: "Closing Quantity", value: "quantity" },
        // { text: "Transfer", value: "transfer" },
        // { text: "Batch", value: "transfer", },
        // { text: "Edit", value: "edit" },
        // { text: "Delete", value: "delete" },
        // { text: "Damage", value: "transfer" },
      ],
       bachList : [],
       batchSelectedProduct : null,
        password:null,
      passwordDialog : false,
      currentPasswordReference : null,
      currentPasswordMethod : null,
    };
  },
  created() {
    this.$bindAsArray("productList", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("godawnTrans", this.$root.$firebaseRefs.godawnTransaction.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("branchs", this.$root.$firebaseRefs.branch.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("branchTrans", this.$root.$firebaseRefs.branchTransaction.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray('productGroups', this.$root.$firebaseRefs.productGroup.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray('productCategories', this.$root.$firebaseRefs.productCategory.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray('productTypes', this.$root.$firebaseRefs.productType.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("batch", this.$root.$firebaseRefs.batchTransaction.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray("damage", this.$root.$firebaseRefs.damageTransaction.orderByChild('brand').equalTo(this.selectedBrand))
    this.$bindAsArray(
      "firmSettings",
      this.$root.$firebaseRefs.firmSettings
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    if(this.$route.params.isNew) {
      this.addProduct();
    }
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","finYear","roleAndPermission"]),
    ...mapGlobalGetters({ units: "productUnit" }),
        productGroupListByBrand() {
      return this.productGroups
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand
          );
        })
        .map(item => {
          return {
            text: item["name"],
            value: item[".key"]
          };
        });
    },
    hasProductAddPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('PRODUCT_ADD')>-1) {
        return true;
      } else {
        return false;
      }
    },

    hasProductEditPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('PRODUCT_EDIT')>-1) {
        return true;
      } else {
        return false;
      }
    },
    
    hasProductDeletePermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('PRODUCT_DELETE')>-1) {
        return true;
      } else {
        return false;
      }
    },
    
    hasProductTransferPermission(){
      if(this.roleAndPermission && 
      this.roleAndPermission.permissions && 
      this.roleAndPermission.permissions.length && 
      this.roleAndPermission.permissions.indexOf('PRODUCT_TRANSFER')>-1) {
        return true;
      } else {
        return false;
      }
    },
    
    productListByBrand() {
      let prod = this.productList.filter(
        item => {
          return (item["brand"] === this.selectedBrand && 
          // (item.openingDate ? (item.openingDate >= this.finYear.start) 
          // && (item.openingDate <= this.finYear.end) : true) 
          (this.selectedGroup ? item['productGroup'] == this.selectedGroup : true) &&
          (this.showOnlyActiveProd ? item['isActive'] == true : true) &&
          (!!this.search ? !!item["name"].toLowerCase().includes(this.search.toLowerCase()) : true))
        }
      );
      if(!this.suggestionAdded) {
        this.compositionSuggestions =[];
      }
      prod.map((p)=>{
        if(!this.suggestionAdded) {
          if(p.composition && this.compositionSuggestions.indexOf(p.composition)==-1) {
            this.compositionSuggestions.push(p.composition)
          }
        }
        if(p.unitsDeatilsAdded  && p.unitsDetails && p.unitsDetails.length) {
          p['openingQuantityTitle']= this.getFilteredQuantity(p,Number.parseFloat(p['openingQuantity']))
          p['purchaseQuantityTitle']= this.getFilteredQuantity(p,Number.parseFloat(p['purchaseQuantity']))
          p['saleQuantityTitle']= this.getFilteredQuantity(p,Number.parseFloat(p['saleQuantity']))
          p['closingQuantityTitle']= this.getFilteredQuantity(p,((Number.parseFloat(p['openingQuantity']) + Number.parseFloat(p['purchaseQuantity'])) -  Number.parseFloat(p['saleQuantity'])))
        }
      })
      return prod;
    },
    godawnByBrand() {
      return this.godawns
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand 
          );
        })
    },
    branchByBrand() {
      return this.branchs
        .filter(item => {
          return (
            item["brand"] === this.selectedBrand 
          );
        })
    }
  },
  methods: {
      getFilteredQuantity(product,qty){
      let quantity = qty;
      let string = "";
          product.unitsDetails.sort(function(a,b){
            return (new Date(b.order) - new Date(a.order));
          });
          for (var i = 0; i < product.unitsDetails.length; i++) {
             if(quantity > Number.parseFloat(product.unitsDetails[i].quantity) && i+1 <product.unitsDetails.length) {
              let temp  = Number.parseFloat(quantity)/Number.parseFloat(product.unitsDetails[i].quantity);
                string = (("("+((temp).toString().split(".")[1] ? (temp).toString().split(".")[1] : 0) + " "+product.unitsDetails[i].unit+") ")+ string);
                quantity = Number.parseInt((temp).toString().split(".")[0])
              } else {
                string = (("("+quantity + " "+product.unitsDetails[i].unit+") ")+ string);
                break;
              }
          }
          // console.log(string)
        return string;
    },
    transferToGodawn(){
      let transferObj = {
        quantity : Number.parseFloat(this.transferQuantity),
        date : new Date(this.transferDate).getTime(),
        product : this.productToTansfer['.key'],
        godawn : this.currentGodawn['.key'],
        brand : this.selectedBrand
      }
      this.$root.$firebaseRefs.godawnTransaction.push(transferObj);
      let key = this.productToTansfer[".key"];
      delete this.productToTansfer[".key"];

      this.transferDialog = false;
      this.transferQuantity = 0;
      this.currentGodawn = null;
      this.productToTansfer = null;
      this.transferDate =  new Date().toISOString().substr(0, 10);
    },
    transferToBranch(){
      let branchObj = {
        quantity : Number.parseFloat(this.branchQuantity),
        date : new Date(this.branchDate).getTime(),
        product : this.productToBranch['.key'],
        branch : this.currentBranch['.key'],
        brand : this.selectedBrand
      }
      this.$root.$firebaseRefs.branchTransaction.push(branchObj);
      let key = this.productToBranch[".key"];
      delete this.productToBranch[".key"];
      this.branchDialog = false;
      this.branchQuantity = 0;
      this.currentBranch = null;
      this.productToBranch = null;
      this.branchDate =  new Date().toISOString().substr(0, 10);
    },

    transferToDamage(){
      let damageObj = {
        quantity : Number.parseFloat(this.damageQuantity),
        date : new Date(this.damageDate).getTime(),
        product : this.productToDamage['.key'],
        // godawn : this.currentGodawn['.key'],
        brand : this.selectedBrand
      }
      this.$root.$firebaseRefs.damageTransaction.push(damageObj);
      let key = this.productToDamage[".key"];
      delete this.productToDamage[".key"];
      // productToDamage['quantity'] = productToDamage['quantity'] - damageObj.quantity;
      // this.$root.$firebaseRefs.products.child(key).set(productToDamage);
      this.productToDamage['quantity'] = this.productToDamage['quantity'] - damageObj.quantity;
      this.$root.$firebaseRefs.products.child(key).set(this.productToDamage);
      
      this.damageDialog = false;
      this.damageQuantity = 0;
      // this.currentGodawn = null;
      this.productToDamage = null;
      this.damageDate =  new Date().toISOString().substr(0, 10);
    },
    addToBatch(){
      let batchObj = {
        quantity : Number.parseFloat(this.batchQuantity),
        openingQuantity : parseInt(this.batchQuantity),
        manufacturingDate : new Date(this.manufacuturingDate).getTime(),
        expiryDate : new Date(this.expiryDate).getTime(),
        product : this.productToBatch['.key'],
        batchNumber: this.batchNumber,
        // godawn : this.currentGodawn['.key'],
        brand : this.selectedBrand
      }
      this.$root.$firebaseRefs.batchTransaction.push(batchObj);
      let key = this.productToBatch[".key"];
      delete this.productToBatch[".key"];
      // productToBatch['quantity'] = productToBatch['quantity'] - transferObj.quantity;
      // this.$root.$firebaseRefs.products.child(key).set(productToBatch);
      
      // this.productToBatch['quantity'] = this.productToBatch['quantity'] - transferObj.quantity;
      // this.$root.$firebaseRefs.products.child(key).set(this.productToBatch);

      this.batchDialog = false;
      this.batchQuantity = 0;
      this.batchNumber ="";
      // this.currentGodawn = null;
      this.productToBatch = null;
      this.manufacuturingDate =  new Date().toISOString().substr(0, 10);
      this.expiryDate =  new Date().toISOString().substr(0, 10);
    },
    openTansferDialog(product){
      this.productToTansfer = product;
      this.transferDialog = true;
    },
    openBranchDialog(product){
      this.productToBranch = product;
      this.branchDialog = true;
    },
    openBatchDialog(product){
      this.productToBatch = product;
      this.batchDialog = true;
    },
    viewProductByBatch(product){
      this.batchSelectedProduct = product;
      this.viewBatchDialog = true;
      this.bachList = this.batch.filter(item => item["brand"] === this.selectedBrand
        && item['product'] == product['.key'])
    },
    openDamageDialog(product){
      this.productToDamage = product;
      this.damageDialog = true;
    },
    duplicateCheck(){
       let duplicateCheck = this.productList.filter(
        item => item["brand"] === this.selectedBrand
        && item['name'] == this.currentProduct.name
      );
      if(duplicateCheck.length) {
          this.duplicateError = 'Product with name ' + this.currentProduct.name + ' Already exist.';
                setTimeout(() => {
                    this.duplicateError = null;
          }, 3000);
      }
    },
    saveProduct(saveAndAdd) {
        this.addProductDialog = false;
        this.snackbar = true;
        if(saveAndAdd) {
          setTimeout(() => {
            this.addProduct();
          }, 1500);
        } else {
           this.stepperValue = 1;
        }
    },
    keymonitor(event){
      this.search = event.target.value;
    },
    addProduct() {
      this.stepperValue = 1;
      this.currentProduct = {
        firm : null,
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        barcode:"",
        productType: null,
        productGroup: null,
        productCategory: null,
        unit: "",
        quantity: 0,
        batchNumber: "",
        openingDate : new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice : 0,
        gstValue : 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        purchasingPricePerProduct: null,
        isActive : true,
        unitsDetails : [
          {
            unit:'',
            isLast: true,
            isFirst:true,
            order : 1,
            quantity : 0
          }
        ],
        sellingPriceByCategories : {}
      };
      this.addProductDialog = true;
    },
    updateProduct() {
      this.addProductDialog = false;
      this.snackbar = true;
      this.stepperValue = 1;
    },
    editProduct(product) {
      this.stepperValue = 1;
      this.currentProduct = JSON.parse(JSON.stringify(product));
      this.currentProduct.openingDate = this.currentProduct.openingDate ? new Date(this.currentProduct.openingDate).toISOString().substr(0, 10) :  new Date().toISOString().substr(0, 10);
      this.currentProduct.quantity = this.currentProduct.openingQuantity;
      this.currentProduct.openingBalance = Number.parseFloat(this.currentProduct.openingBalance)
      this.addProductDialog = true;
      if(!this.currentProduct.sellingPriceByCategories) {
        this.currentProduct.sellingPriceByCategories = {};
      }
      if(!this.currentProduct.unitsDeatilsAdded) {
        this.currentProduct.unitsDetails = [
          {
            unit:'',
            isLast: true,
            isFirst:true,
            order : 1,
            quantity : 0
          }
        ]
      }
    },
    deleteFromDialog(){
      this[this.currentPasswordMethod](this.currentPasswordReference);
    },
    deleteProduct(product) {
       let firmSettings = this.firmSettings.find(i => i['firm'] == product.firm);
      let hasPassword = firmSettings && firmSettings.deleteWithPassword && !!firmSettings.deleteInvoicePassword;
      if(hasPassword && this.password != firmSettings.deleteInvoicePassword && this.passwordDialog) {
        alert("Incorrect Password")
        this.passwordDialog = false;
        this.password = null;
      } else if (hasPassword && !this.passwordDialog){
        this.passwordDialog = true;
        this.password = null;
        this.currentPasswordReference = product;
        this.currentPasswordMethod = "deleteProduct";
      }
      else if (window.confirm("Do you want to Delete ?")) {
        this.passwordDialog = false;
        this.password = null;
        this.$root.$firebaseRefs.products.child(product[".key"]).remove();
        this.stepperValue = 1;
      }
    }
  },
};
</script>
<style>
.search .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: rgb(255, 255, 255);
}

.search .theme--light.v-label {
  color: rgb(255, 255, 255);
}

.search .theme--light.v-clearable {
  color: rgb(255, 255, 255);
}

.search .theme--light.v-outlined {
  color: rgb(255, 255, 255);
  border-color: white;
}

.search {
  width: 50%;
  margin-left: 7%;
  margin-right: 7%;
}

.search .v-text-field > .v-input__control > .v-input__slot:after {
    border-color: white;
}

.theme--light.v-select.white-select .v-select__selections {
    color: rgb(255 255 255 / 87%);
}

.theme--light.v-text-field.white-select > .v-input__control > .v-input__slot:before {
    border-color: rgb(255 255 255 / 42%);
}

.white-select .theme--light.v-label{
    color: rgb(255 255 255);
}

.search .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: white;
}

.theme--light .white-switch {
  margin-top: 25px !important;
}

.theme--light .white-switch .v-label,.theme--light .white-select .v-label  {
  color: white;
}

</style>



// WEBPACK FOOTER //
// src/components/Products/product.vue